import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Authorize from '@/views/Authorize.vue'
import Callback from '@/views/Callback';
import ProductionUnit from '@/views/ProductionUnit';
import { requireAuth } from './utils/auth';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/production-unit/:id',
      name: 'productionUnit',
      component: ProductionUnit,
      beforeEnter: requireAuth
    },
    {
      path: '/authorize',
      name: 'authorize',
      component: Authorize
    },
    {
      path: '/callback',
      component: Callback,
    }
  ]
})
